import { SelectType } from "@appquality/appquality-design-system";

export const setSelectedBug = (
  bugId?: number,
): BugShowActions_SetSelectedBug => ({
  type: "bugShow/setSelectedBug",
  payload: bugId,
});

export const setSeverities = (
  severities: SelectType.Option[],
): BugShowActions_SetSeverities => ({
  type: "bugShow/setSeverities",
  payload: severities,
});

export const setStatus = (
  status: SelectType.Option[],
): BugShowActions_SetStatus => ({
  type: "bugShow/setStatus",
  payload: status,
});

export const setTags = (tags: SelectType.Option[]): BugShowActions_SetTags => ({
  type: "bugShow/setTags",
  payload: tags,
});

export const setSelectedSeverity = (
  severity?: SelectType.Option,
): BugShowActions_SetSelectedSeverity => ({
  type: "bugShow/setSelectedSeverity",
  payload: severity,
});

export const setSelectedStatus = (
  status?: SelectType.Option,
): BugShowActions_SetSelectedStatus => ({
  type: "bugShow/setSelectedStatus",
  payload: status,
});

export const setSelectedTags = (
  tags?: SelectType.Option[],
): BugShowActions_SetSelectedTags => ({
  type: "bugShow/setSelectedTags",
  payload: tags,
});

export const setReplicabilities = (
  replicabilities: SelectType.Option[],
): BugShowActions_SetReplicabilities => ({
  type: "bugShow/setReplicabilities",
  payload: replicabilities,
});

export const setSelectedReplicability = (
  replicability?: SelectType.Option,
): BugShowActions_SetSelectedReplicability => ({
  type: "bugShow/setSelectedReplicability",
  payload: replicability,
});

export const setBugTypes = (
  bugTypes: SelectType.Option[],
): BugShowActions_SetBugTypes => ({
  type: "bugShow/setBugTypes",
  payload: bugTypes,
});

export const setSelectedBugType = (
  bugType?: SelectType.Option,
): BugShowActions_SetSelectedBugType => ({
  type: "bugShow/setSelectedBugType",
  payload: bugType,
});

export const setIsLoading = (
  isLoading: boolean,
): BugShowActions_SetIsLoading => ({
  type: "bugShow/setIsLoading",
  payload: isLoading,
});

export const setSearch = (
  search: string,
): BugShowActions_SetSearch => ({
  type: "bugShow/setSearch",
  payload: search,
});
